import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 46px;

    @media (max-width: 700px) {
        gap: 15px;
    }
`;

export const ContentData = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const DataValueInfor = styled.div``;

export const ContaintableButton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const ContentFilterLine = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

`;

export const Status = styled.div<{ isPay: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    border: 1px solid ${(props) => (props.isPay ? props.theme.colors.success : props.theme.colors.warning)};
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    color: ${(props) => (props.isPay ? props.theme.colors.success : props.theme.colors.warning)};
    border-radius: 4px;
    padding: 3px 5px;
    font-size: 12px;
    
    svg{
        color: ${(props) => (props.isPay ? props.theme.colors.success : props.theme.colors.warning)};
    }
`;

export const ContentTable = styled.table`
    width: 100%;
    border-collapse: collapse;

    thead {
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        top: 0;
        z-index: 1;
    }
    
    th:last-child,
    td:last-child,
    th:nth-child(1),
    td:nth-child(1) {
        width: 85px;
    }

    tbody {
        display: block;
        max-height: 500px;
        overflow-y: auto;
        width: 100%;
    }

    tbody::-webkit-scrollbar { 
        display: none;
    }

    tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    }

    td,
    th {
        text-align: center;
        padding: 10px 0;
    }

    td > div {
        display: flex;
        justify-content: space-around;
    }
    
    & svg {
        font-size: 18px;
    }

    @media (max-width: 900px) {
        th:nth-child(5), 
        td:nth-child(5) {
            display: none;
        }

        th:nth-child(1),
        td:nth-child(1),
        th:last-child,
        td:last-child {
            width: 50px;
        }

        tbody {
            max-height: 450px;
        }
    }
`;

export const ContentPopMenu = styled.div`
`;

export const ButtonTable = styled.button`
    display: flex;
    justify-content: center;

    padding: 8px;
    
    border-radius: 30px;
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    background-color: ${(props) => props.theme.colors.white};
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const CheckBox = styled.input`
  width: 18px;
  height: 18px;
  appearance: none;
  cursor: pointer;

  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.gray.gray_100};

  &:checked {
    background-color: ${(props) => props.theme.colors.primary};
    border-color: ${(props) => props.theme.colors.primary}; /* Borda ao marcar */
  }

  &:hover {
    border-color:${(props) => props.theme.colors.primary}; /* Cor ao passar o mouse */
  }

  &::after {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    margin: 3px auto;
    color: ${(props) => props.theme.colors.white};
    opacity: 0;
    transition: opacity 0.2s ease;
  }
`;

export const ContentButton = styled.div`
`;